import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'simple-input-dialog',
    styleUrls: ['./simple-input-dialog.component.scss'],
    template: `
    <h2 mat-dialog-title>{{data?.title}}</h2>
    <mat-dialog-content class="mat-typography">
    <p><input #layoutname type="text" autoComplete="off" class="input-layout margin-left-right" title="Name of new layout version" [ngModel]="data.layoutname"
    (ngModelChange)="data.layoutname = $event" cdkFocusInitial></p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
    <button class="color" mat-button [mat-dialog-close]="cancel()">Cancel</button>
    <span class="spacer"></span>
    <button class="color" mat-button [mat-dialog-close]="save()">Save</button>
    </mat-dialog-actions>
    `
})
export class SimpleInputDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data, private dialogRef: MatDialogRef<SimpleInputDialog>) {
        dialogRef.disableClose = true;
    }

    cancel() {
        return {state:false}
    }

    save() {
        return {state:true,layoutname:this.data.layoutname};
    }
}